import React from 'react';
import {
	Container,
	ContainerGutter,
	List,
	ListGutter,
	ListItem,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { ServiceGroupType, ServiceLayer } from '../../models/services-layer-types';

export const preItvLayer: ServiceLayer = {
	id: ServiceGroupType.Coberturas,
	header: 'Coberturas',
	title: 'Revisión pre-ITV',
	subtitle: (
		<Text appearance={TokenTextAppearance.copy200}>
			En tu Servicio Oficial revisarán tu Volkswagen al detalle para comprobar si está listo para pasar la ITV.
		</Text>
	),
	description: (
		<Container wrap="always" gutter={ContainerGutter.dynamic0100}>
			<Text appearance={TokenTextAppearance.headline200} bold>
				Esto es todo lo que incluye la revisión:
			</Text>
			<Text appearance={TokenTextAppearance.copy200}>
				<List gutter={ListGutter.dynamic0020}>
					<ListItem>Carrocería y chasis: limpiaparabrisas, puertas, retrovisores y lunas.</ListItem>
					<ListItem>Interior: airbags, cinturones, anclajes y cuadro de instrumentos.</ListItem>
					<ListItem>Alumbrado y señalización.</ListItem>
					<ListItem>Motor y transmisión: nivel del líquido refrigerante y nivel de aceite del motor.</ListItem>
					<ListItem>Emisiones contaminantes.</ListItem>
					<ListItem>Ejes, ruedas, neumáticos y suspensión.</ListItem>
					<ListItem>Dirección.</ListItem>
					<ListItem>
						Sistema de frenos: estado de los discos, nivel del líquido de frenos y estado de las pastillas.
					</ListItem>
				</List>
			</Text>
		</Container>
	),
	imageContent:
		'https://assets.volkswagen.com/is/image/volkswagenag/layer-pre-itv?Zml0PWNyb3AlMkMxJndpZD04OTYmaGVpPTg5NiZmbXQ9anBlZyZxbHQ9NzkmYmZjPW9mZiZlMmRh',
	ctaText: 'Pide cita en tu taller',
	link: 'action:es-cca-loader--open_layer',
};
